import { fetchSingleOutcome } from 'actions';
import Outcome from 'components/Outcome';
import { RouteSpec, SuperRouteSpec } from 'types';

const ruleRoutes: (RouteSpec | SuperRouteSpec)[] = [
  {
    name: 'rule-campaign-outcome-id',
    path: '/:customerDomain/rule/:ruleId?/campaign/:campaignId?/outcome/:outcomeId',
    component: Outcome,
    private: true,
    permissions: 'outcomes.retrieve',
    data: {
      idFromPath: true,
      actions: [fetchSingleOutcome],
    },
  },

  {
    path: '/rules',
    component: (): null => null,
    private: true,
  },
];

export default ruleRoutes;
